import React from "react";

export const Header = () => {
  return (
    <>
      <header id="site-header" className="header">
        <div id="header-wrap">
          <div className="container-fluid">
            <div className="row">
              <div className="col">
                <nav
                  className="navbar navbar-expand-lg"
                  style={{ padding: "7px 20px" }}
                >
                  <a className="navbar-brand logo" href="index.html">
                    <img
                      className="img-fluid"
                      src="./assets/images/logo.png"
                      alt=""
                    />
                  </a>
                  <button
                    className="navbar-toggler ht-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <svg width="100" height="100" viewBox="0 0 100 100">
                      <path
                        className="line line1"
                        d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"
                      ></path>
                      <path className="line line2" d="M 20,50 H 80"></path>
                      <path
                        className="line line3"
                        d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"
                      ></path>
                    </svg>
                  </button>
                  <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="nav navbar-nav mx-auto">
                      <li className="nav-item dropdown">
                        <a className="nav-link " href="/">
                          Home
                        </a>
                      </li>
                      <li className="nav-item dropdown">
                        <a className="nav-link " href="/about-us">
                         About Us
                        </a>
                      </li>

                      <li className="nav-item dropdown">
                        <a
                          className="nav-link dropdown-toggle"
                          href="#"
                          data-bs-toggle="dropdown"
                        >
                          Services
                        </a>
                        <ul className="dropdown-menu">
                          <li>
                            <a href="/search-engine-optimization">SEO (Search Engine Optimization)</a>
                          </li>
                          <li>
                            <a href="/answer-engine-optimization">AEO (Answer Engine Optimization)</a>
                          </li>
                          <li>
                            <a href="/Geographical-Seo">GEO (Geographical SEO)</a>
                          </li>
                          <li>
                            <a href="/Digital-Marketing-Solutions">Digital Marketing Solutions</a>
                          </li>
                        </ul>
                      </li>

                      <li className="nav-item dropdown">
                        <a className="nav-link" href="/ContactUs">
                          Contact
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div
                    className="header-right align-items-center"
                    style={{ display: "flex" }}
                  >
                    <a className="header-btn" href="">
                      Let's Chat <i className="bi bi-arrow-right"></i>
                    </a>
                    <a href="#" className="ht-nav-toggle">
                      <i className="bi bi-grid-fill"></i>
                    </a>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>

      <nav id="ht-main-nav">
        <a href="#" className="ht-nav-toggle">
          <i className="bi bi-x-lg"></i>
        </a>
        <a className="navbar-brand logo" href="index.html">
          <img className="img-fluid" src="./assets/images/logo.png" alt="" />{" "}
        </a>
        <p className="mt-3">
          We specialize in AEO (Answer Engine Optimization), GEO-targeted SEO,
          and comprehensive digital marketing strategies that put your brand in
          front of the right audience — at the right time.
        </p>
        <div className="form-info">
          <h4 className="mb-4">Contact Info</h4>
          <div className="contact-link">
            <ul className="contact-info list-unstyled">
              <li>
                <i className="flaticon flaticon-gps-1"></i>
                <span>Address:</span>
                <p>
                  #10, 2nd Floor, Bldg no: 210 Nuaija, Al Hilal, Doha - Qatar.
                </p>
              </li>
              <li>
                <i className="flaticon flaticon-email"></i>
                <span>Email:</span>
                <a href="mailto:info@foxmedia.qa">info@foxmedia.qa</a>
              </li>
              <li>
                <i className="flaticon flaticon-mobile"></i>
                <span>Phone:</span>
                <a href="tel:+974 - 7059 8308">+974 - 7059 8308</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="social-icons mt-5">
          <ul className="list-inline">
            <li>
              <a href="#">
                <i className="flaticon-facebook-app-symbol"></i>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="flaticon-twitter-2"></i>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="flaticon-instagram"></i>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="flaticon-linkedin-1"></i>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};
